import React from 'react'
import PropTypes from 'prop-types'

export const BundlesPriceModalStyles = {
  modal: {
    width: '850px',
    height: '345px',
    borderRadius: '4px',
    top: '11%',
    left: '26%',
  },
  header: {
    padding: '30px 60px 10px 30px',
  },
  title: {
    height: '28px',
    top: '156px',
    gap: '32px',
    width: '332px',
    fontFamily: 'Lato',
    fontSize: '24px',
    fontWeight: '800',
    lineHeight: '28px',
    letterSpacing: '2%',
    color: '#1C1C1B',
  },
  body: {
    width: '100%',
    height: '10%',
    padding: '20px 60px 30px 30px',
    fontFamily: 'Lato',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.3px',
    verticalAlign: 'middle',
    color: '#343331',
  },
  footer: {
    border: 'none',
  },
  button: {
    width: '177px',
    height: '48px',
    top: '292px',
    left: '994px',
    gap: '4px',
    borderRadius: '5px',
    padding: '8px 40px',
    backgroundColor: '#FF8135',
    border: 'none',
    color: '#FFFFFF',
    cursor: 'default',
  },
}

export const BundlePriceButton = ({ onClick, children, style }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ ...BundlesPriceModalStyles.button, ...style }}
    >
      {children}
    </button>
  )
}

BundlePriceButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}
